module.exports = __webpack_public_path__ + "static/spacing-4.dc14b959.svg";